module.exports = __webpack_public_path__ + "16496c459532dc869a0d9c1f16a01370.jpg";